import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { Site } from '../administration/gestion-sites/model/site.model';
import { SiteService } from '../administration/gestion-sites/site.service';
import { SiteStore } from '../administration/gestion-sites/store/site.store';

export const siteResolver: ResolveFn<Observable<Site>> = (route) => {
  const siteService = inject(SiteService);
  const siteStore = inject(SiteStore);
  const idSite = route.params['idSite'] as string;

  return siteService.trouverParId(idSite).pipe(
    tap((site) => {
      siteStore.select(site);
    }),
  );
};
